import {
  BOOKING_IN_PROGRESS_BREADCRUMBS_TEXT,
  INITIAL_BREADCRUMBS_LIST,
} from "../../../constant/bookingInProgressConstant";
import { BreadCrumTypes } from "../../../types";

export { };

// const afterIndex = {
//   checked: false,
//   activeCrumbs: false,
// };
// const beforeIndex = {
//   checked: true,
//   activeCrumbs: false,
// };
// export function moveToHotel(setBreadList: any, setActiveBreadCrumbs: any) {
//   let prevList: any = []
//   let afterHotel = false;
//   setBreadList((prev: BreadCrumTypes[]) => {
//     prevList = prev.map((ele: BreadCrumTypes) => {
//       if (ele?.value === BOOKING_IN_PROGRESS_BREADCRUMBS_TEXT.Hotels) {
//         afterHotel = true;
//         return { ...ele, checked: true, activeCrumbs: true };
//       } else if (afterHotel) return { ...ele, ...afterIndex };
//       return { ...ele, ...beforeIndex };
//     })
//     return prevList
//   }
//   );
//   if (prevList?.length)
//     setActiveBreadCrumbs(prevList?.filter((ele: BreadCrumTypes) => ele?.activeCrumbs)[0])
// }
// export function moveToFlight(setBreadList: any, setActiveBreadCrumbs: any) {
//   let prevList: any = []
//   let afterFlight = false;
//   setBreadList((prev: BreadCrumTypes[]) => {
//     prevList = prev.map((ele: BreadCrumTypes) => {
//       if (ele?.value === BOOKING_IN_PROGRESS_BREADCRUMBS_TEXT.Flights) {
//         afterFlight = true;
//         return { ...ele, checked: true, activeCrumbs: true };
//       } else if (afterFlight) return { ...ele, ...afterIndex };
//       return { ...ele, ...beforeIndex };
//     })
//     return prevList
//   }
//   );
//   if (prevList?.length)
//     setActiveBreadCrumbs(prevList?.filter((ele: BreadCrumTypes) => ele?.activeCrumbs)[0])
// }

// export function moveToReview(setBreadList: any, setActiveBreadCrumbs: any) {
//   let prevList: any = []
//   let afterFlight = false;
//   setBreadList((prev: BreadCrumTypes[]) => {
//     prevList = prev.map((ele: BreadCrumTypes) => {
//       if (ele?.value === BOOKING_IN_PROGRESS_BREADCRUMBS_TEXT.Review) {
//         afterFlight = true;
//         return { ...ele, checked: true, activeCrumbs: true };
//       } else if (afterFlight) return { ...ele, ...afterIndex };
//       return { ...ele, ...beforeIndex };
//     })
//     return prevList
//   }
//   );
//   if (prevList?.length)
//     setActiveBreadCrumbs(prevList?.filter((ele: BreadCrumTypes) => ele?.activeCrumbs)[0])
// }

// export function flightOrHotelSelect(selectedFlightOptions: any, setBreadList: any, setActiveBreadCrumbs: any) {
//   if (selectedFlightOptions?.flights && selectedFlightOptions?.hotels) {
//     setBreadList(INITIAL_BREADCRUMBS_LIST);
//     setActiveBreadCrumbs(INITIAL_BREADCRUMBS_LIST?.filter((ele: BreadCrumTypes) => ele?.activeCrumbs)[0])
//     return INITIAL_BREADCRUMBS_LIST
//   } else if (selectedFlightOptions?.flights) {
//     let breadList = INITIAL_BREADCRUMBS_LIST
//     breadList = breadList.filter((ele: BreadCrumTypes) => ele?.value !== BOOKING_IN_PROGRESS_BREADCRUMBS_TEXT.Hotels)
//     breadList = breadList.filter((ele: BreadCrumTypes) => ele?.value !== BOOKING_IN_PROGRESS_BREADCRUMBS_TEXT.TravelersHotel)
//     breadList = breadList.map((ele: BreadCrumTypes, index: number) => {
//       if (index === 0) {
//         return { ...ele, checked: true, activeCrumbs: true };
//       }
//       return { ...ele, checked: false, activeCrumbs: false };
//     })
//     setBreadList(breadList)
//     setActiveBreadCrumbs(breadList?.filter((ele: BreadCrumTypes) => ele?.activeCrumbs)[0])
//     return breadList
//   } else if (selectedFlightOptions?.hotels) {
//     let breadList = INITIAL_BREADCRUMBS_LIST
//     breadList = breadList.filter((ele: BreadCrumTypes) => ele?.value !== BOOKING_IN_PROGRESS_BREADCRUMBS_TEXT.Flights)
//     breadList = breadList.map((ele: BreadCrumTypes, index: number) => {
//       if (index === 0) {
//         return { ...ele, checked: true, activeCrumbs: true };
//       }
//       return { ...ele, checked: false, activeCrumbs: false };
//     })
//     setBreadList(breadList)
//     setActiveBreadCrumbs(breadList?.filter((ele: BreadCrumTypes) => ele?.activeCrumbs)[0])
//     return breadList
//   } else {
//     setBreadList(INITIAL_BREADCRUMBS_LIST);
//     setActiveBreadCrumbs(INITIAL_BREADCRUMBS_LIST?.filter((ele: BreadCrumTypes) => ele?.activeCrumbs)[0])
//     return INITIAL_BREADCRUMBS_LIST
//   }
// }

const afterIndex = {
  checked: false,
  activeCrumbs: false,
};
const beforeIndex = {
  checked: true,
  activeCrumbs: false,
};

export function moveToHotel(setBreadList: any, setActiveBreadCrumbs: any) {
  setBreadList((prev: BreadCrumTypes[]) => {
    let afterHotel = false;
    const updated = prev.map((ele: BreadCrumTypes) => {
      if (ele?.value === BOOKING_IN_PROGRESS_BREADCRUMBS_TEXT.Hotels) {
        afterHotel = true;
        return { ...ele, checked: true, activeCrumbs: true };
      } else if (afterHotel) {
        return { ...ele, ...afterIndex };
      }
      return { ...ele, ...beforeIndex };
    });

    const active = updated.find((ele) => ele.activeCrumbs);
    if (active) setActiveBreadCrumbs(active);

    return updated;
  });
}

export function moveToFlight(setBreadList: any, setActiveBreadCrumbs: any) {
  setBreadList((prev: BreadCrumTypes[]) => {
    let afterFlight = false;
    const updated = prev.map((ele: BreadCrumTypes) => {
      if (ele?.value === BOOKING_IN_PROGRESS_BREADCRUMBS_TEXT.Flights) {
        afterFlight = true;
        return { ...ele, checked: true, activeCrumbs: true };
      } else if (afterFlight) {
        return { ...ele, ...afterIndex };
      }
      return { ...ele, ...beforeIndex };
    });

    const active = updated.find((ele) => ele.activeCrumbs);
    if (active) setActiveBreadCrumbs(active);

    return updated;
  });
}

export function moveToReview(setBreadList: any, setActiveBreadCrumbs: any) {
  setBreadList((prev: BreadCrumTypes[]) => {
    let afterReview = false;
    const updated = prev.map((ele: BreadCrumTypes) => {
      if (ele?.value === BOOKING_IN_PROGRESS_BREADCRUMBS_TEXT.ReviewNew) {
        afterReview = true;
        return { ...ele, checked: true, activeCrumbs: true };
      } else if (afterReview) {
        return { ...ele, ...afterIndex };
      }
      return { ...ele, ...beforeIndex };
    });

    const active = updated.find((ele) => ele.activeCrumbs);
    if (active) setActiveBreadCrumbs(active);

    return updated;
  });
}

export function flightOrHotelSelect(
  selectedFlightOptions: any,
  setBreadList: any,
  setActiveBreadCrumbs: any
) {
  if (selectedFlightOptions?.flights && selectedFlightOptions?.hotels) {
    setBreadList(INITIAL_BREADCRUMBS_LIST);
    setActiveBreadCrumbs(
      INITIAL_BREADCRUMBS_LIST.find((ele) => ele?.activeCrumbs)
    );
    return INITIAL_BREADCRUMBS_LIST;
  } else if (selectedFlightOptions?.flights) {
    let breadList = INITIAL_BREADCRUMBS_LIST.filter(
      (ele: BreadCrumTypes) =>
        ele?.value !== BOOKING_IN_PROGRESS_BREADCRUMBS_TEXT.Hotels &&
        ele?.value !==
        BOOKING_IN_PROGRESS_BREADCRUMBS_TEXT.TravelersHotel
    ).map((ele: BreadCrumTypes, index: number) => {
      if (index === 0) {
        return { ...ele, checked: true, activeCrumbs: true };
      }
      return { ...ele, checked: false, activeCrumbs: false };
    });

    setBreadList(breadList);
    setActiveBreadCrumbs(breadList.find((ele) => ele.activeCrumbs));
    return breadList;
  } else if (selectedFlightOptions?.hotels) {
    let breadList = INITIAL_BREADCRUMBS_LIST.filter(
      (ele: BreadCrumTypes) =>
        ele?.value !== BOOKING_IN_PROGRESS_BREADCRUMBS_TEXT.Flights
    ).map((ele: BreadCrumTypes, index: number) => {
      if (index === 0) {
        return { ...ele, checked: true, activeCrumbs: true };
      }
      return { ...ele, checked: false, activeCrumbs: false };
    });

    setBreadList(breadList);
    setActiveBreadCrumbs(breadList.find((ele) => ele.activeCrumbs));
    return breadList;
  } else {
    setBreadList(INITIAL_BREADCRUMBS_LIST);
    setActiveBreadCrumbs(
      INITIAL_BREADCRUMBS_LIST.find((ele) => ele?.activeCrumbs)
    );
    return INITIAL_BREADCRUMBS_LIST;
  }
}
